import React, { useState, useEffect } from "react";
import domainUrl from "../../../common/config/domainUrl";
import apiCall from "../../../common/config/apiCall";
import apiKey from "../../../common/config/apiKey";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { nextPage } from "../../../common/config/nextPage";
// Sweet alert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
// End Sweet Alert

function StripeForm({
  handleSyncBooking,
  total,
  firstName,
  lastName,
  email,
  mobile,
  airport,
  discountCode,
  handleValidate,
  responseError,
  supplierCost,
  service,
  stripePaymentIntent,
  api_tag,
  reference_no,
  isVehicle,
  product,
  setAgree,
  agree,
  error,
}) {
  // console.log(reference_no,"reference_no")
  const stripe = useStripe();
  const elements = useElements();
  const [state, setState] = useState("initial");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationStatus = handleValidate();

    if (validationStatus?.length > 0) {
      return;
    }

    if (responseError.length > 0) {
      setState("error");
      setStatus("error");
      return;
    }
    if (validationStatus) {
      setState("loading");
      setStatus("");

      if (!stripe || !elements) {
        return;
      }
      let response = await handleSyncBooking();

      console.log(response, 'response');
      // CHECK IF USER ALREADY HAS MADE THE PAYMENT THEN REDIRECT

      let validateIntent = await await apiCall(
        "post",
        "/stripe/paymentIntent/retrieve",
        { key: apiKey, payment_intent_id: stripePaymentIntent, api_tag },
        {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      );

      if (validateIntent?.status === "succeeded") {

        nextPage(
          `/success?bookingReference=${
            response?.multi_mode_reference_no
          }&reference_no=${
            response?.reference_no
          }&transactionID=${stripePaymentIntent}&paymentIntent=${stripePaymentIntent}&paymentMethod=Stripe&suppliercost=${supplierCost.toFixed(
            2
          )}&name=${firstName}${lastName}&email=${email}&mobile=${mobile}&totalamount=${total.toFixed(
            2
          )}&airport=${airport}&service=${service}&discountCode=${discountCode}&api_tag=${api_tag}&sku=${product?.sku}`
        );
      }
      // Swal.fire({
      //   title: "<p>PROCESSING YOUR PAYMENT PLEASE WAIT.....</p>",
      //   allowOutsideClick: false,
      //   heightAuto: false,
      //   backdrop: true,
      //   didOpen: () => {
      //     MySwal.showLoading();
      //   },
      //   willClose: () => {
      //     clearInterval(2000);
      //   },
      // });
      // END CHECKING STRIPE

      if (response?.reference_no?.length) {
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: `${domainUrl}/success?bookingReference=${
              response?.multi_mode_reference_no
            }&reference_no=${
              response?.reference_no
            }&transactionID=${stripePaymentIntent}&paymentIntent=${stripePaymentIntent}&paymentMethod=Stripe&suppliercost=${supplierCost.toFixed(
              2
            )}&name=${firstName}${lastName}&email=${email}&mobile=${mobile}&totalamount=${total.toFixed(
              2
            )}&airport=${airport}&service=${service}&discountCode=${discountCode}&api_tag=${api_tag}&sku=${product?.sku}`,
          },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
          setStatus(error?.message || "Something went wrong");
          setState("initial");
          // Swal.close();
        } else {
          setStatus("An unexpected error occurred.");
          setState("initial");
          // Swal.close();
        }
        setState("initial");
        setState("error");
      }
    }
  };

  return (
    <div className="mx-auto rounded-2xl shadow-md bg-white border border-slate-200 overflow-hidden mt-5" id="payment-form">
      {/* Header bar */}
      <div className="bg-gradient-to-r from-primary from-[80%] to-secondary px-6 py-4 text-white font-semibold text-lg md:text-xl">
        Payment Details
      </div>

      <div className="p-3 md:p-6">
        {responseError?.length ? (
          <div className="bg-red-50 text-red-600 border border-red-200 p-4 rounded-xl text-center font-bold mb-5 shadow-sm">
            {responseError}
          </div>
        ) : null}

        <PaymentElement
          id="payment-element"
          options={{
            defaultValues: {
              billingDetails: {
                address: {
                  country: "gb",
                },
              },
            },
          }}
        />

        {/* Checkbox and Terms */}
        <div className="flex flex-col gap-1 md:pt-6 pt-3">
          <div className="flex items-center gap-3">
            <div
              className={
                reference_no.length > 0
                  ? "cursor-pointer select-none"
                  : "opacity-60 pointer-events-none select-none"
              }
              onClick={() => reference_no.length > 0 && setAgree(!agree)}
            >
              <div className={`flex items-center justify-center w-6 h-6 rounded-lg border-2 transition-all duration-200 ${
                agree
                  ? "bg-secondary border-secondary text-primary"
                  : "bg-slate-100 border-slate-300 text-transparent"
              }`}>
                <span className="text-sm font-black">✓</span>
              </div>
            </div>
            <div className="discount">
              <p
                className={
                  reference_no.length > 0
                    ? "text-slate-700 hover:text-primary transition-all md:text-base text-[14px] font-semibold cursor-pointer select-none"
                    : "opacity-60 pointer-events-none md:text-base text-[14px] font-semibold cursor-not-allowed select-none"
                }
                onClick={() => reference_no.length > 0 && setAgree(!agree)}
              >
                I agree to the terms & conditions!
              </p>
            </div>
          </div>
          {error?.agree?.length ? (
            <p className="text-[13px] text-red-500 font-semibold mt-1 pl-9">
              {error.agree}
            </p>
          ) : null}
        </div>

        {/* Submit button */}
        <div className="flex items-center justify-center pt-6 btn-container">
          <button
            className={`text-base md:text-lg w-full py-4 px-6 bg-gradient-to-r from-primary from-[80%] to-secondary text-white font-bold rounded-xl flex items-center justify-center shadow-md transition-all active:scale-[0.98] ${
              state === "loading" || !stripe || !elements
                ? "opacity-60 cursor-not-allowed"
                : "hover:opacity-95"
            }`}
            disabled={state === "loading" || !stripe || !elements}
            type="button"
            onClick={handleSubmit}
          >
            {state === "loading" ? (
              <div className="flex items-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Processing payment...</span>
              </div>
            ) : (
              <span>Confirm Payment</span>
            )}
          </button>
        </div>

        {/* Error status display */}
        {status ? (
          <div className="bg-red-50 text-red-600 border border-red-200 p-5 rounded-2xl text-center font-bold mt-6 shadow-sm">
            {status?.toUpperCase()}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default StripeForm;
